import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightThinIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14.8 12.2",
	style: { enableBackground: "new 0 0 14.8 12.2" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.arrow-right-thin-st0{opacity:0.3;}\n	.arrow-right-thin-st1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
		className: "st0",
		children: [/* @__PURE__ */ _jsx("path", {
			className: "arrow-right-thin-st1",
			d: "M0.5,6.1h13.8"
		}), /* @__PURE__ */ _jsx("path", {
			className: "arrow-right-thin-st1",
			d: "M8.7,0.5l5.6,5.6l-5.6,5.6"
		})]
	}) }) }) })]
});
export default SvgArrowRightThinIcon;
